import { z } from "zod";
export const IBAN_INVALID_MESSAGE = "Cet IBAN semble incorrect. Vérifiez-le sur votre relevé bancaire, puis réessayez.";
export const IbanSchema = z
    .string()
    .transform((value) => {
    const withoutWhitespace = value.replace(/\s/g, "");
    const compact = withoutWhitespace.replace(/[-./\u2010\u2011\u2013\u2014]/g, "");
    return (compact || withoutWhitespace).replace(/[a-z]/g, (letter) => letter.toUpperCase());
})
    .refine((value) => value === "" || isValidIban(value), { message: IBAN_INVALID_MESSAGE });
export function formatIban(value) {
    const result = IbanSchema.safeParse(value);
    if (!result.success || !result.data) {
        return value;
    }
    return result.data.replace(/(.{4})(?=.)/g, "$1 ");
}
function isValidIban(value) {
    if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(value)) {
        return false;
    }
    const checkDigits = Number(value.slice(2, 4));
    if (checkDigits < 2 || checkDigits > 98) {
        return false;
    }
    const rearranged = value.slice(4) + value.slice(0, 4);
    let remainder = 0;
    for (const character of rearranged) {
        const code = character.charCodeAt(0);
        remainder =
            code >= 65 ? (remainder * 100 + code - 55) % 97 : (remainder * 10 + code - 48) % 97;
    }
    return remainder === 1;
}
//# sourceMappingURL=iban.js.map